import {Box, Button} from '@mui/material';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {UserCanAny} from '../UserCan';
import {
  isGTSelector,
  productLevelSelector,
} from '../../store/Slices/companySlice';

const scopes = {
  radioMode: 'is-admin,partner',
  manualSongs: 'is-admin,partner,manual-song-clips:list',
  walkup:
    'is-admin,partner,music-walkup:list,music-walkup:create,music-walkup:update',
  songSets:
    'is-admin,partner,song-sets:list,song-sets:create,song-sets:update,song-sets:duplicate',
  templatePattern:
    'is-admin,template-pattern:list,template-pattern:create,template-pattern:delete',
  musicSchedule:
    'is-admin,partner,music-schedules:list,music-schedules:create,music-schedules:update',
  onDemandSchedule:
    'is-admin,partner,on-demand-playlist:list,on-demand-playlist:create,on-demand-playlist:update,on-demand-playlist:delete',
  preScheduleEvent: 'is-admin,partner,pre-scheduled-events:list',
  blackList:
    'is-admin,partner,blacklisted-artist:list,blacklisted-artist:create,blacklisted-artist:delete,blacklisted-song:list,blacklisted-song:create,blacklisted-song:delete,blacklisted-tag:list,blacklisted-tag:create,blacklisted-tag:delete,blacklisted-bpm:view,blacklisted-bpm:update',
  partnerGenreSelection:
    'is-admin,partner-genre-management:list,partner-genre-management:create,partner-genre-management:update,partner-genre-management:delete',
};

export const levelZero = 'Level 0 (ODO Only)';

const buttons = [
  {
    condition: (isGT: boolean, productLevel: string) =>
      isGT && productLevel !== levelZero,
    scope: scopes.radioMode,
    type: 'radio-mode',
    label: 'Radio Mode',
    path: '/music/radio-mode',
  },
  {
    condition: (isGT: boolean) => !isGT,
    scope: scopes.musicSchedule,
    type: 'music-schedules',
    label: 'Music Schedules',
    path: '/music/music-schedules',
  },
  {
    condition: (isGT: boolean, productLevel: string) =>
      isGT && productLevel !== levelZero,
    scope: scopes.preScheduleEvent,
    type: 'pre-scheduled-events',
    label: 'Pre-scheduled Events',
    path: '/music/pre-scheduled-events',
  },
  {
    condition: () => true,
    scope: scopes.onDemandSchedule,
    type: 'on-demand',
    label: 'On Demand',
    path: '/music/on-demand',
  },
  {
    condition: () => true,
    scope: scopes.walkup,
    type: 'walkup',
    label: 'Walk Ups / Lineups',
    path: '/music/walkup',
  },
  {
    condition: (isGT: boolean) => !isGT,
    scope: scopes.songSets,
    type: 'song-sets',
    label: 'Song Sets',
    path: '/music/song-set',
  },
  {
    condition: () => true,
    scope: scopes.manualSongs,
    type: 'manual-song-clips',
    label: 'Manual Songs/Clips',
    path: '/music/manual-song-clips',
    sx: {whiteSpace: 'nowrap'},
  },
  {
    condition: () => true,
    scope: scopes.blackList,
    type: 'blacklist-songs-artists',
    label: 'Blacklist',
    path: '/music/blacklist-songs-artists',
  },
  {
    condition: () => true,
    scope: scopes.partnerGenreSelection,
    type: 'manage-genre',
    label: 'Manage Genres',
    path: '/music/manage-genre',
    sx: {whiteSpace: 'nowrap'},
  },
  {
    condition: () => true,
    scope: scopes.templatePattern,
    type: 'template-pattern',
    label: 'Template',
    path: '/music/template-pattern',
  },
];

const MusicPlaylistNavButtons = ({type}: {type: string}) => {
  const isGT = useSelector(isGTSelector);
  const productLevel = useSelector(productLevelSelector);

  return (
    <Box className='flex gap-3 flex-wrap m-2'>
      {buttons.map(
        ({condition, scope, type: btnType, label, path, sx}, index) => {
          if (!condition(isGT, productLevel)) return null;
          return scope ? (
            <UserCanAny key={index} scope={scope}>
              <Button
                color='primary'
                size='small'
                variant={type === btnType ? 'contained' : 'outlined'}
                component={Link}
                to={path}
                sx={sx}>
                {label}
              </Button>
            </UserCanAny>
          ) : null;
        },
      )}
    </Box>
  );
};

export default MusicPlaylistNavButtons;
